export const API_PORT = import.meta.env.VITE_APP_API_PORT || 8000;
export const FRONTEND_PORT = import.meta.env.VITE_APP_FRONTEND_PORT || 3000;
export const RSS_LINKS_PORT = import.meta.env.VITE_APP_RSS_LINKS_PORT || 3000;

export const STAGE = import.meta.env.VITE_APP_STAGE ?? "development";
